import type { CSSProperties } from 'react';

/** Edge shadow marking the boundary between the frozen (sticky) columns and the scrolling content. */
export const FROZEN_EDGE_SHADOW = '6px 0 6px -4px rgba(0,0,0,0.15)';

/**
 * Inline style for a frozen (sticky-left) table cell. Shared by the outer clonotype table and the
 * inner sequence table so the sticky-positioning shape lives in one place instead of being
 * duplicated in each table's JSX.
 */
export function frozenCellStyle(left: number | string, showEdgeShadow: boolean, zIndex: number, background: string): CSSProperties {
  return {
    position: 'sticky',
    left,
    zIndex,
    background,
    boxShadow: showEdgeShadow ? FROZEN_EDGE_SHADOW : undefined,
  };
}
